import { useContext } from 'react'
import { DownloadsProviderContext } from '../provider/context'
import { DownloadsProviderContextProps } from '../models/provider.model'

export const useDownloadsContext = (): DownloadsProviderContextProps => {
  const context = useContext(DownloadsProviderContext)

  if (!context) {
    throw new Error('useDownloadsContext must be used within a DownloadsProvider')
  }

  return context
}
